import { render, staticRenderFns } from "./MioLocationPerformance.vue?vue&type=template&id=f631bc24&"
import script from "./MioLocationPerformance.vue?vue&type=script&lang=js&"
export * from "./MioLocationPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports